import React, { useEffect, useState } from "react";

import "./ncr.css";
import leftArrow from "../../assets/Images/left-arrow.png";
import rightArrow from "../../assets/Images/right-arrow.png";
import { PROJECT_API } from "../../services/apiCalls/projectApiCalls";
import { toast } from "react-toastify";
import Filter from "../../assets/Icons/filter.png";
import Download from "../../assets/Icons/download.png";
import { Modal } from "react-responsive-modal";
import "react-responsive-modal/styles.css";
import Close from "../../assets/Images/close.png";
import ExcelExport from "../../compnenets/commons/xls";
import DownloadIcon from "../../assets/Icons/Download_Icon.png";

function NCR(props) {
  // console.log(props);
  const [type, setType] = useState("list");
  const [ncrId, setNcrId] = useState("");
  const handleChangeTab = () => {
    setType("form");
  };
  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 10;

  const [ncrData, setNcrData] = useState([]);
  const usr = localStorage.getItem("state");
  const state = JSON.parse(usr);
  const [formData, setFormData] = useState({
    ProjectID: props.project.project_id,
    ProjectNumber: props.project.Project_Number,
    ProjectName: props.project.Project_Name,
    ProjectLocation: props.project.Location,
    Region: props.project.Region,
    Product: "test",
    Solution: "test",
    ExecutionPartner: props.project.Execution_partner,
    ComponentManufacturer: props.project.ComponentManufacturer,
    SiteVisitDate_AuditDate: "",
    DescriptionofWork: "",
    Observationrelatedto: "",
    Protocolsmaintainedforthesaidactivity: "",
    ObservationBy: "",
    BriefDescriptionoftheobservation: "",
    ObservationCategory: "",
    Proposedcorrectiveaction: "",
    ObservationClosed: "",
    Addphoto_video: null,
    Observationtobeclosedby_Nameofdepartment: "",
    UserID: state?.user?.user_id,
    NatureofActivity: "",
  });
  const handleInputChange = (e) => {
    const { name, value, type, files } = e.target;
    setFormData({
      ...formData,
      [name]: type === "file" ? files[0] : value,
    });
  };

  const totalPages = Math.ceil(ncrData.length / rowsPerPage);

  const handleClick = (page) => {
    setCurrentPage(page);
  };

  const paginatedData = ncrData.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );
  const handleRowClick = (ncr) => {
    // debugger;
    console.log(ncr, "ncr----");

    setNcrId(ncr.QualityNCRID);
    setFormData({
      QualityNCRID: ncr.QualityNCRID,
      ProjectID: ncr.ProjectID || "",
      ProjectNumber: ncr.ProjectNumber || "",
      ProjectName: ncr.ProjectName || "",
      ProjectLocation: ncr.ProjectLocation || "",
      Region: ncr.Region || "",
      Product: "test",
      Solution: "test",
      ExecutionPartner: ncr.ExecutionPartner || "",
      ComponentManufacturer: ncr.ComponentManufacturer || "",
      SiteVisitDate_AuditDate: ncr.SiteVisitDate_AuditDate
        ? new Date(ncr.SiteVisitDate_AuditDate).toISOString().split("T")[0]
        : "",
      DescriptionofWork: ncr.DescriptionofWork || "",
      Observationrelatedto: ncr.Observationrelatedto || "",
      Protocolsmaintainedforthesaidactivity:
        ncr.Protocolsmaintainedforthesaidactivity || "",
      ObservationBy: ncr.ObservationBy || "",
      BriefDescriptionoftheobservation:
        ncr.BriefDescriptionoftheobservation || "",
      ObservationCategory: ncr.ObservationCategory || "",
      Proposedcorrectiveaction: ncr.Proposedcorrectiveaction || "",
      ObservationClosed: ncr.ObservationClosed || "",
      Addphoto_video: ncr.Addphoto_video || null,
      Observationtobeclosedby_Nameofdepartment:
        ncr.Observationtobeclosedby_Nameofdepartment || "",
      UserID: ncr.UserID || "",
      NatureofActivity: ncr.NatureofActivity || "",
    });

    setType("form");
  };

  const handleSubmit = async () => {
    for (const [key, value] of Object.entries(formData)) {
      if (value === "" || value === null || value === undefined) {
        toast.error(`Please fill the ${key} field.`);
        return;
      }
    }
    let file = { fileUrl: formData.Addphoto_video };
    if (typeof formData.Addphoto_video === "object") {
      file = await PROJECT_API.saveDocument(formData.Addphoto_video);
    }

    const updatedFormData = {
      ...formData,
      Addphoto_video: file.fileUrl,
    };

    const response = await PROJECT_API.createUpdateNcr(updatedFormData);
    if (response.Status === 200) {
      toast.success(`NCR ${ncrId ? "updated" : "created"} successfully!`);
      setType("list");
      setFormData({
        ProjectID: props.project.project_id,
        ProjectNumber: props.project.Project_Number,
        ProjectName: props.project.Project_Name,
        ProjectLocation: props.project.Location,
        Region: props.project.Region,
        Product: "test",
        Solution: "test",
        ExecutionPartner: props.project.Execution_partner,
        ComponentManufacturer: props.project.ComponentManufacturer,
        SiteVisitDate_AuditDate: "",
        DescriptionofWork: "",
        Observationrelatedto: "",
        Protocolsmaintainedforthesaidactivity: "",
        ObservationBy: "",
        BriefDescriptionoftheobservation: "",
        ObservationCategory: "",
        Proposedcorrectiveaction: "",
        ObservationClosed: "",
        Addphoto_video: null,
        Observationtobeclosedby_Nameofdepartment: "",
        UserID: state?.user?.user_id,
        NatureofActivity: "",
      });
      fetchNcrData();
    }
  };

  const fetchNcrData = async () => {
    setCurrentPage(1);
    const usr = localStorage.getItem("state");
    const state = JSON.parse(usr);
    const payload = {
      UserID: state?.user?.user_id,
    };
    const ncr = await PROJECT_API.getNCRlist(payload);
    if (ncr && ncr.QualityNCRlist?.length) {
      setNcrData(ncr.QualityNCRlist);
    }
  };
  useEffect(() => {
    fetchNcrData();
  }, []);

  const onCloseModalFilter = () => {};
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFilterData((prev) => ({ ...prev, [name]: value }));
  };

  const [openFilter, setOpenFilter] = useState(false);
  const [filterData, setFilterData] = useState({
    user_id: state?.user?.user_id,
    startDate: "",
    endDate: "",
    NatureofActivity: "",
    ObservationClosed: "",
    ObservationCategory: "",
    sortOrder: "ASC",
    sortBy: "Site Vist/Audit Date",
  });
  const handleFilterClick = async () => {
    setCurrentPage(1);
    const ncr = await PROJECT_API.getNCRlist(filterData);
    if (ncr && ncr.QualityNCRlist?.length) {
      setNcrData(ncr.QualityNCRlist);
    }
    setOpenFilter(false);
  };
  function truncateFileNameFromPath(fileName, maxLength) {
    const dotIndex = fileName.lastIndexOf(".");
    if (dotIndex === -1) {
      return fileName;
    }

    const name = fileName.substring(0, dotIndex);
    const extension = fileName.substring(dotIndex);

    if (fileName.length > maxLength) {
      const visibleLength = maxLength - 1 - extension.length;
      const startLength = Math.ceil(visibleLength / 2);
      const endLength = Math.floor(visibleLength / 2);
      const truncatedName = `${name.substring(
        0,
        startLength
      )}...${name.substring(name.length - endLength)}`;
      return `${truncatedName}${extension}`;
    }

    return fileName;
  }
  const downloadFile = (fileUrl) => {
    const link = document.createElement("a");
    link.href = fileUrl;
    console.log(fileUrl?.split("/").pop());
    link.setAttribute("download", fileUrl?.split("/").pop());
    // link.download = decodeURIComponent(fileUrl?.split('/').pop());
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link); // Clean up the DOM
  };
  return (
    <>
      <Modal open={openFilter} onClose={onCloseModalFilter} center>
        <div className="d-flex justify-content-between">
          <div>
            <span className="resorces">Quality NCR Filter</span>
          </div>
          <div>
            <img
              src={Close}
              width={20}
              onClick={() => setOpenFilter(false)}
              style={{ cursor: "pointer" }}
            />
          </div>
        </div>
        <hr />
        <div className="row">
          <div className="card mt-0 card-bd-none">
            <div className="card-body">
              <div className="row">
                <div className="col-6">
                  <label className="filter-label">Start date</label>
                  <input
                    type="date"
                    name="startDate"
                    value={filterData.startDate}
                    onChange={handleChange}
                    className="form-control shadow-none"
                  />
                </div>
                <div className="col-6">
                  <label className="filter-label">End date</label>
                  <input
                    type="date"
                    name="endDate"
                    value={filterData.endDate}
                    onChange={handleChange}
                    className="form-control shadow-none"
                  />
                </div>
              </div>

              <div className="row mt-1">
                <div className="col-6">
                  <label className="filter-label">Nature of activity</label>
                  <input
                    type="text"
                    name="NatureofActivity"
                    value={filterData.NatureofActivity}
                    onChange={handleChange}
                    className="form-control shadow-none"
                  />
                </div>
                <div className="col-6">
                  <label className="filter-label">Observation Status</label>
                  <select
                    name="ObservationClosed"
                    value={filterData.ObservationClosed}
                    onChange={handleChange}
                    className="filter-label"
                    style={{
                      width: "100%",
                      height: 31,
                      border: "1px solid #e6e3e3",
                      borderRadius: 4,
                    }}
                  >
                    <option value="">Select observation status</option>
                    <option value="1">Yes</option>
                    <option value="0">No</option>
                  </select>
                </div>
              </div>

              <div className="row mt-1">
                <div className="col-6">
                  <label className="filter-label">Observation Category</label>
                  <select
                    name="ObservationCategory"
                    value={filterData.ObservationCategory}
                    onChange={handleChange}
                    className="filter-label"
                    style={{
                      width: "100%",
                      height: 31,
                      border: "1px solid #e6e3e3",
                      borderRadius: 4,
                    }}
                  >
                    <option value="">Select observation category</option>
                    <option value="1">Yes</option>
                    <option value="0">No</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="d-flex justify-content-between">
            <div style={{ marginLeft: 20 }}>
              <span className="resorces">Sort Manpower</span>
            </div>
            <div style={{ marginRight: 20 }}>
              <select
                name="sortOrder"
                value={filterData.sortOrder}
                onChange={handleChange}
                className="filter-label"
                style={{
                  width: "100%",
                  height: 31,
                  border: "1px solid #e6e3e3",
                  borderRadius: 4,
                }}
              >
                <option value="ASC">ASC</option>
                <option value="DES">DES</option>
              </select>
            </div>
          </div>
        </div>

        <div className="row" style={{ marginLeft: 20 }}>
          {["Site Vist/Audit Date", "Created Date", "Nature of Activity"].map(
            (sortOption) => (
              <div className="form-check" key={sortOption}>
                <input
                  className="form-check-input shadow-none"
                  type="radio"
                  name="sortBy"
                  id={sortOption}
                  value={sortOption}
                  checked={filterData.sortBy === sortOption}
                  onChange={handleChange}
                />
                <label htmlFor={sortOption} style={{ fontSize: 14 }}>
                  {sortOption}
                </label>
              </div>
            )
          )}
        </div>

        <div className="d-flex justify-content-center mt-4 pb-4">
          <button
            className="btn btn-primary"
            onClick={() => handleFilterClick(filterData)}
          >
            Filter
          </button>
        </div>
      </Modal>
      <div
        className="select-tab d-flex align-items-center"
        style={{ marginTop: "10px", justifyContent: "space-between" }}
      >
        <div className="d-flex align-items-center flex-grow-1">
          <div
            className={`tab ${type === "list" ? "tab-active" : ""}`}
            onClick={() => setType("list")}
            style={{ whiteSpace: "nowrap" }}
          >
            NCR List
          </div>
          <div
            className={`tab ${type === "form" ? "tab-active" : ""} ml-3`}
            onClick={() => handleChangeTab()}
            style={{ whiteSpace: "nowrap", marginLeft: "15px" }}
          >
            NCR Form
          </div>
        </div>
        {type === "list" && (
          <div className="d-flex justify-content-end align-items-center">
            <div className="download-icon">
              <ExcelExport
                data={ncrData?.map((val) => {
                  return {
                    "Project Name": val.ProjectName,
                    "Project Location": val.ProjectLocation,
                    Region: val.Region,
                    "Project Number": val.ProjectNumber,
                    "Execution Partner": val.ExecutionPartner,
                    "Component Manufacturer": val.ComponentManufacturer,
                    "Site Visit Date": val.SiteVisitDate_AuditDate,
                    "Nature of Activity": val.NatureofActivity,
                    "Observation Closed": val.ObservationClosed,
                    UserID: val.UserID,
                    Product: val.Product,
                    Solution: val.Solution,
                    "Description of Work": val.DescriptionofWork,
                    "Observation related to": val.Observationrelatedto,
                    "Protocols maintained for the said activity":
                      val.Protocolsmaintainedforthesaidactivity,
                    "Observation By": val.ObservationBy,
                    "Brief Description of the observation":
                      val.BriefDescriptionoftheobservation,
                    "Observation Category": val.ObservationCategory,
                    "Proposed corrective action": val.Proposedcorrectiveaction,
                    Addphoto_video: val.Addphoto_video,
                    "Observation to be closed by(Name of department)":
                      val.Observationtobeclosedby_Nameofdepartment,
                  };
                })}
                fileName="NCR List"
                sheet="NCR List"
              />
            </div>
            <div className="filter-icon mx-2 my-auto">
              <img
                className=""
                onClick={() => {
                  setOpenFilter(true);
                }}
                src={Filter}
                width={20}
              />
            </div>
            <div className="my-auto">
              <span
                style={{
                  cursor: "pointer",
                  fontSize: 12,
                  fontWeight: 500,
                  background: "#8add79f7",
                  padding: 5,
                  borderRadius: 12,
                }}
                onClick={() => {
                  fetchNcrData();
                  setCurrentPage(1);
                }}
              >
                Clear filters
              </span>
            </div>
          </div>
        )}
      </div>

      {type === "form" ? (
        <>
          <div className="card p-4 mt-3">
            <div class="container">
              <div class="row">
                <div class="col-md-3">
                  <label class="input-label" for="ProjectNumber">
                    Project Number
                  </label>
                  <input
                    class="input-style form-control"
                    type="text"
                    name="ProjectNumber"
                    id="ProjectNumber"
                    value={props.project.Project_Number}
                    // onChange={handleInputChange}
                    disabled
                  />
                </div>
                <div class="col-md-3">
                  <label class="input-label" for="ProjectName">
                    Project Name
                  </label>
                  <input
                    class="input-style form-control"
                    type="text"
                    name="ProjectName"
                    id="ProjectName"
                    value={props.project.Project_Name}
                    // onChange={handleInputChange}
                    disabled
                  />
                </div>
                <div class="col-md-3">
                  <label class="input-label" for="ProjectLocation">
                    Project Location
                  </label>
                  <input
                    class="input-style form-control"
                    type="text"
                    name="ProjectLocation"
                    id="ProjectLocation"
                    value={props.project.Project_Name}
                    // onChange={handleInputChange}
                    disabled
                  />
                </div>
                <div class="col-md-3">
                  <label class="input-label" for="region">
                    Region
                  </label>
                  <input
                    class="input-style form-control"
                    type="text"
                    name="region"
                    id="region"
                    value={props.project.Region}
                    onChange={handleInputChange}
                    disabled
                  />
                </div>
              </div>

              <div class="row mt-3">
                <div class="col-md-3">
                  <label class="input-label" for="product">
                    Product
                  </label>
                  <input
                    class="input-style form-control"
                    type="text"
                    name="product"
                    id="product"
                    value={formData.product}
                    onChange={handleInputChange}
                    disabled
                  />
                </div>
                <div class="col-md-3">
                  <label class="input-label" for="solution">
                    Solution
                  </label>
                  <input
                    class="input-style form-control"
                    type="text"
                    name="solution"
                    id="solution"
                    value={formData.solution}
                    onChange={handleInputChange}
                    disabled
                  />
                </div>
                <div class="col-md-3">
                  <label class="input-label" for="ExecutionPartner">
                    Execution Partner
                  </label>
                  <input
                    class="input-style form-control"
                    type="text"
                    name="ExecutionPartner"
                    id="ExecutionPartner"
                    value={props.project.Execution_partner}
                    onChange={handleInputChange}
                    disabled
                  />
                </div>
                <div class="col-md-3">
                  <label class="input-label" for="ComponentManufacturer">
                    Component Manufacturer
                  </label>
                  <input
                    class="input-style form-control"
                    type="text"
                    name="ComponentManufacturer"
                    id="ComponentManufacturer"
                    value={props.project.ComponentManufacturer}
                    onChange={handleInputChange}
                    disabled
                  />
                </div>
              </div>

              <div class="row mt-3">
                <div class="col-md-3">
                  <label class="input-label" for="ObservationBy">
                    Observation By
                  </label>
                  <input
                    class="input-style form-control"
                    type="text"
                    name="ObservationBy"
                    id="ObservationBy"
                    value={formData.ObservationBy}
                    onChange={handleInputChange}
                    // placeholder="Enter observation by "
                  />
                </div>
                <div class="col-md-3">
                  <label
                    class="input-label"
                    for="BriefDescriptionoftheobservation"
                  >
                    Brief Description of the observation
                  </label>
                  <textarea
                    class="input-style form-control"
                    // type="text"
                    name="BriefDescriptionoftheobservation"
                    id="BriefDescriptionoftheobservation"
                    maxLength={200}
                    value={formData.BriefDescriptionoftheobservation}
                    onChange={handleInputChange}
                    // placeholder="Enter DescriptionofWork of the observation"
                  />
                </div>

                <div class="col-md-3">
                  <label class="input-label" for="ObservationCategory">
                    Observation Category
                  </label>
                  <select
                    class="input-style"
                    type="text"
                    name="ObservationCategory"
                    id="ObservationCategory"
                    value={formData.ObservationCategory}
                    onChange={handleInputChange}
                  >
                    <option value=""></option>
                    <option value="test">Test</option>
                  </select>
                </div>
                <div class="col-md-3">
                  <label class="input-label" for="Proposedcorrectiveaction">
                    Proposed corrective action
                  </label>
                  <textarea
                    class="input-style form-control"
                    // type="text"
                    name="Proposedcorrectiveaction"
                    id="Proposedcorrectiveaction"
                    value={formData.Proposedcorrectiveaction}
                    onChange={handleInputChange}
                    // placeholder="Enter proposed corrective action"
                  />
                </div>
              </div>
              <div class="row mt-3">
                <div class="col-md-3">
                  <label class="input-label" for="SiteVisitDate_AuditDate">
                    Site Visit Date/Audit Date
                  </label>
                  <input
                    class="input-style form-control"
                    type="date"
                    name="SiteVisitDate_AuditDate"
                    id="SiteVisitDate_AuditDate"
                    value={formData.SiteVisitDate_AuditDate}
                    onChange={handleInputChange}
                  />
                </div>
                <div class="col-md-3">
                  <label class="input-label" for="DescriptionofWork">
                    Description of Work
                  </label>
                  <textarea
                    class="input-style form-control"
                    // type="text"
                    name="DescriptionofWork"
                    id="DescriptionofWork"
                    maxLength={200}
                    value={formData.DescriptionofWork}
                    onChange={handleInputChange}
                    // placeholder="Enter description of work"
                  />
                </div>
                <div class="col-md-3">
                  <label class="input-label" for="Observationrelatedto">
                    Observation related to
                  </label>
                  <input
                    class="input-style form-control"
                    type="text"
                    name="Observationrelatedto"
                    id="Observationrelatedto"
                    value={formData.Observationrelatedto}
                    onChange={handleInputChange}
                    // placeholder="Enter observation related to"
                  />
                </div>
                <div class="col-md-3">
                  <label
                    class="input-label"
                    for="Protocolsmaintainedforthesaidactivity"
                  >
                    Protocols maintained for the said activity
                  </label>
                  <input
                    class="input-style form-control"
                    type="text"
                    name="Protocolsmaintainedforthesaidactivity"
                    id="Protocolsmaintainedforthesaidactivity"
                    value={formData.Protocolsmaintainedforthesaidactivity}
                    onChange={handleInputChange}
                    // placeholder="Enter Protocolsmaintainedforthesaidactivity"
                  />
                </div>
              </div>
              <div class="row mt-3">
                <div class="col-md-3">
                  <label class="input-label" for="NatureofActivity">
                    Nature of activity
                  </label>
                  <select
                    class="input-style"
                    type="text"
                    name="NatureofActivity"
                    id="NatureofActivity"
                    value={formData.NatureofActivity}
                    onChange={handleInputChange}
                  >
                    <option value=""></option>
                    <option value="1">Yes</option>
                    <option value="0">No</option>
                  </select>
                </div>
                <div class="col-md-3">
                  <label class="input-label" for="ObservationClosed">
                    Observation closed
                  </label>
                  <select
                    class="input-style"
                    type="text"
                    name="ObservationClosed"
                    id="ObservationClosed"
                    value={formData.ObservationClosed}
                    onChange={handleInputChange}
                  >
                    <option value=""></option>
                    <option value="1">Yes</option>
                    <option value="0">No</option>
                  </select>
                </div>
                <div class="col-md-3">
                  <label class="input-label" for="Addphoto_video">
                    Add photo/video
                  </label>
                  <input
                    class="input-style form-control"
                    type="file"
                    name="Addphoto_video"
                    id="Addphoto_video"
                    // value={formData.Addphoto_video}
                    onChange={handleInputChange}
                    style={{ height: "33px" }}
                  />
                  {typeof formData.Addphoto_video !== "object" &&
                    formData.Addphoto_video !== "" && (
                      <>
                        <div
                          className="d-flex align-items-center justify-center"
                          style={{ marginTop: "10px" }}
                        >
                          {/* <img
                          src={PdfIcon}
                          alt="PDF Icon"
                          style={{ width: "16px", marginRight: "8px" }}
                        /> */}
                          <div className="d-flex" style={{ fontSize: "14px" }}>
                            {truncateFileNameFromPath(
                              decodeURIComponent(
                                formData.Addphoto_video.split("/").pop()
                              ),
                              19
                            )}
                          </div>

                          <img
                            src={DownloadIcon}
                            alt="Download Icon"
                            style={{
                              width: "16px",
                              marginLeft: "8px",
                              cursor: "pointer",
                            }}
                            onClick={(e) => {
                              e.stopPropagation();
                              downloadFile(formData.Addphoto_video);
                            }}
                          />
                        </div>
                      </>
                    )}
                </div>

                <div class="col-md-3">
                  <label
                    class="input-label"
                    for="Observationtobeclosedby_Nameofdepartment"
                  >
                    Observation to be closed by (Name of department)
                  </label>
                  <input
                    class="input-style form-control"
                    type="text"
                    name="Observationtobeclosedby_Nameofdepartment"
                    id="Observationtobeclosedby_Nameofdepartment"
                    value={formData.Observationtobeclosedby_Nameofdepartment}
                    onChange={handleInputChange}
                    // placeholder="Enter name of the department"
                  />
                </div>
              </div>
            </div>

            <div className="action-div">
              <div className="button-div">
                <button
                  className="btn btn-submit"
                  onClick={() => handleSubmit()}
                >
                  Submit
                </button>
                <button
                  className="btn btn-cancel"
                  onClick={() => {
                    setNcrId("");
                    setFormData({
                      ProjectID: props.project.project_id,
                      ProjectNumber: props.project.Project_Number,
                      ProjectName: props.project.Project_Name,
                      ProjectLocation: props.project.Location,
                      Region: props.project.Region,
                      Product: "test",
                      Solution: "test",
                      ExecutionPartner: props.project.Execution_partner,
                      ComponentManufacturer:
                        props.project.ComponentManufacturer,
                      SiteVisitDate_AuditDate: "",
                      DescriptionofWork: "",
                      Observationrelatedto: "",
                      Protocolsmaintainedforthesaidactivity: "",
                      ObservationBy: "",
                      BriefDescriptionoftheobservation: "",
                      ObservationCategory: "",
                      Proposedcorrectiveaction: "",
                      ObservationClosed: "",
                      Addphoto_video: null,
                      Observationtobeclosedby_Nameofdepartment: "",
                      UserID: state?.user?.user_id,
                      NatureofActivity: "",
                    });
                    setType("list");
                  }}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </>
      ) : (
        <>
          {/* <div className="card p-4 mt-3">List</div> */}
          <div
            className="table-container"
            style={{
              marginLeft: "0px",
              marginRight: "0px",
              marginTop: "10px",
            }}
          >
            <table className="custom-table">
              <thead className="table-header">
                <tr>
                  <th>Sr No</th>
                  <th>Project Number</th>
                  <th>Project Name</th>
                  <th>Project Location</th>
                  <th>Region</th>
                  <th>Product</th>
                  <th>Solution </th>
                  <th>Execution Partner</th>
                  <th>Component Manufacturer</th>
                  <th>Site Visit Date/Audit Date</th>
                  <th>Nature of Activity</th>
                  <th>Description of Work</th>
                  {/* <th>Photo/Video</th> */}
                </tr>
              </thead>
              <tbody>
                {paginatedData.map((ncr, index) => (
                  <tr key={ncr.id} onClick={() => handleRowClick(ncr)}>
                    <td>{index + 1 + (currentPage - 1) * 10}</td>
                    <td>{ncr.ProjectNumber}</td>
                    <td>{ncr.ProjectName}</td>
                    <td>{ncr.ProjectLocation}</td>
                    <td>{ncr.Region}</td>
                    <td>{ncr.Product}</td>
                    <td>{ncr.Solution}</td>
                    <td>{ncr.ExecutionPartner}</td>
                    <td>{ncr.ComponentManufacturer}</td>
                    <td>{ncr.SiteVisitDate_AuditDate}</td>
                    <td>{ncr.NatureofActivity}</td>
                    <td>{ncr.DescriptionofWork}</td>
                  </tr>
                ))}
              </tbody>
            </table>
            <div
              className="pagination"
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "10px 15px",
              }}
            >
              <div style={{ fontSize: "14px", whiteSpace: "nowrap" }}>
                Showing{" "}
                {Math.min((currentPage - 1) * rowsPerPage + 1, ncrData.length)}
                to {Math.min(currentPage * rowsPerPage, ncrData.length)} of{" "}
                {ncrData.length} entries
              </div>

              <div
                className="pagination-buttons"
                style={{
                  fontSize: "14px",
                  display: "flex",
                  justifyContent: "flex-end",
                  width: "100%",
                  gap: "5px",
                }}
              >
                <button
                  onClick={() => handleClick(Math.max(1, currentPage - 1))}
                  disabled={currentPage === 1}
                  style={{
                    background: "none",
                    border: "none",
                    cursor: currentPage === 1 ? "not-allowed" : "pointer",
                  }}
                >
                  <img
                    src={leftArrow}
                    alt="Previous"
                    height="10px"
                    width="10px"
                    style={{ opacity: currentPage === 1 ? 0.5 : 1 }}
                  />
                </button>

                {[...Array(totalPages)].map((_, i) => (
                  <button
                    key={i}
                    onClick={() => handleClick(i + 1)}
                    style={{
                      background:
                        currentPage === i + 1 ? "#00B69B" : "transparent",
                      color: currentPage === i + 1 ? "#fff" : "#000",
                      border: "none",
                      borderRadius: "50%",
                      width: "30px",
                      height: "30px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      cursor: "pointer",
                    }}
                  >
                    {i + 1}
                  </button>
                ))}

                <button
                  onClick={() =>
                    handleClick(Math.min(totalPages, currentPage + 1))
                  }
                  disabled={currentPage === totalPages}
                  style={{
                    background: "none",
                    border: "none",
                    cursor:
                      currentPage === totalPages ? "not-allowed" : "pointer",
                  }}
                >
                  <img
                    src={rightArrow}
                    alt="Next"
                    height="10px"
                    width="10px"
                    style={{
                      opacity: currentPage === totalPages ? 0.5 : 1,
                    }}
                  />
                </button>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
}

export default NCR;
